import React from "react";
//#region types
import { TranslationKeys } from "translations";
import { UtilFormTypes } from "models/formTypes";
import { BaseFormExpandableStepProps } from "models/propTypes/wintFormPropsTypes";
import { getCostForwardingSectionSubText } from "./costForwardingMarkingModel";
//#endregion
//#region components
import { ExpandableSection, ExpandableSectionSummary } from "components/common/wintForms";
import CostForwardingFields from "./costForwardingFields";
import { useCostForwardingMarkingContext } from "./costForwardingMarkingContext";
import { getCostForwardingSectionSubTextText } from "./costForwardingStatusText";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

/** The "Vidarefakturering" step shared by the receipt and supplier invoice to-do forms. */
const CostForwardingSection: React.FC<BaseFormExpandableStepProps<UtilFormTypes.CostForwardingMarking>> = ({
  connect,
  values,
  expandableStepProps,
}) => {
  const { marking } = useCostForwardingMarkingContext();

  return (
    <ExpandableSection
      summary={
        <ExpandableSectionSummary
          title={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.CostForwarding.Title)}
          subText={getCostForwardingSectionSubTextText(getCostForwardingSectionSubText(marking))}
        />
      }
      initiallyOpen={marking !== undefined}
      hasErrors={connect("costForwardingCustomer").hasErrors || connect("costForwardingDescription").hasErrors}
      {...expandableStepProps}
    >
      <CostForwardingFields connect={connect} values={values} marking={marking} />
    </ExpandableSection>
  );
};

export default CostForwardingSection;
